import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';

import Icon from '@mdi/react';
import { mdiPhoneOutline, mdiEmailOutline } from '@mdi/js';

import BulmaFooter from 'react-bulma-components/lib/components/footer';
import {
  Column,
  Container,
  Row,
  Section,
} from 'components/UIComponents/Layout';
import CookieNotification from '../CookieNotification';
import { Heading } from 'components/UIComponents/Typography';
import { COOKIE_CONSENT_AGREED_NAME } from 'utils/cookieUtils';

import fondLogo from '../../assets/img/fond_logo.jpg';
import './style.scss';

const Footer = () => {
  const { t } = useTranslation();

  const [cookies] = useCookies([COOKIE_CONSENT_AGREED_NAME]);
  const [showCookieNotification, setShowCookieNotification] = useState(false);

  const handleShowCookieNotification = isShown => {
    setShowCookieNotification(previousValue => {
      return cookies[COOKIE_CONSENT_AGREED_NAME] === undefined
        ? isShown
        : !previousValue;
    });
  };

  return (
    <>
      <CookieNotification
        show={showCookieNotification}
        onShow={handleShowCookieNotification}
      />
      <footer>
        <BulmaFooter>
          <Container>
            <Section>
              <Row>
                <Column>
                  <Heading size={5}>
                    {t('datagate.external.global.footer.statisticsInfo')}
                  </Heading>
                  <ul>
                    <li>
                      <Icon path={mdiPhoneOutline} size={0.75} />
                      +372 625 9300
                    </li>
                    <li>
                      <Icon path={mdiEmailOutline} size={0.75} />
                      <a href="mailto:adminandmed@stat.ee">adminandmed@stat.ee</a>
                    </li>
                  </ul>
                </Column>
                <Column>
                  <Heading size={5}>
                    {t('datagate.external.global.footer.feedback')}
                  </Heading>
                  <p>
                    <Trans
                      components={{
                        feedbackLink: (
                          <a
                            className="feedbackLink"
                            href={t(
                              'datagate.external.global.footer.feedbackLink'
                            )}
                          >
                            {' '}
                          </a>
                        ),
                      }}
                    >
                      datagate.external.global.footer.feedbackMessage
                    </Trans>
                  </p>
                  <br />
                  <p>
                    {t('datagate.external.global.footer.appVersion')}:{' '}
                    <b>{process.env.REACT_APP_VERSION}</b>
                  </p>
                </Column>
                <Column>
                  <div>
                    <a
                      href="#cookie-notification"
                      onClick={e => {
                        e.preventDefault();
                        handleShowCookieNotification(true);
                      }}
                    >
                      {t('datagate.external.cookie.compliance.settings')}
                    </a>
                  </div>
                </Column>
                <Column className="is-one-quarter-desktop is-one-third-tablet">
                  <div>
                    <img
                      src={fondLogo}
                      className="fond-logo-mobile"
                      alt="Struktuurfondi logo"
                    />
                  </div>
                </Column>
              </Row>
            </Section>
          </Container>
        </BulmaFooter>
      </footer>
    </>
  );
};

export default Footer;
